import type { Psdata } from '@vue-storefront/prestashop-api';

export const useCartItem = (product: ComputedRef<Pick<Psdata, 'id_product'| 'id_product_attribute' | 'quantity' | 'availability' > | null>) => {
  const { data: cart } = useCart();

  const quantityInCart = computed(() => {
    const item = cart.value?.products?.find((item) => {
      return item.id_product == product.value?.id_product && item.id_product_attribute == product.value?.id_product_attribute;
    });
    return item?.quantity ?? 0;
  });

  const quantityAvailable = computed(() => {
    return Math.max(0, (product.value?.quantity ?? 0) - quantityInCart.value);
  });

  const quantitySelectable = computed(() => {
    const availability = product.value?.availability?.toLowerCase();
    if (!availability || availability === 'unavailable' || availability === 'outofstock') return 0;
    // API says available or backorder — trust it.
    // Cap by stock if we have it, otherwise unlimited.
    const stock = (product.value?.quantity ?? 0) - quantityInCart.value;
    return stock > 0 ? stock : 99;
  });

  const isAvailable = computed(() => {
    return quantitySelectable.value > 0;
  });

  return {
    quantityInCart,
    quantitySelectable,
    quantityAvailable,
    isAvailable,
  };
};
